import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.10.0_3deaa5576ccbfaf05268e5bac8380424/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}